<template>
    <div class="">
        <div class="postavitev-slike">
            <img src="/static/img/Nastavitve/ElektronskaPosta/layer1.png" alt="">
        </div>
        <div class="postavitev-vsebine">
            <p class="navadno-besedilo">
                Na vašem uporabniškem računu še nimate ustvarjenega T-2 elektronskega naslova.
            </p>
            <div style="padding-top: 20px">
                <p class="navadno-besedilo">
                    T-2 zagotavlja brezplačne elektronske predale za vsakega družinskega člana, ali zaposlenega v
                    primeru naročenih poslovnih storitev, s kapaciteto 1 GB.
                    <br/>
                    Vabimo vas, da si ustvarite svojega.
                </p>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'KomponentaBrezEpredalov'
  }
</script>

<style scoped src="../../../../../../static/css/Nastavitve/Email/KomponentaBrezPredalov.css">
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Nastavitve/ElektronskaPosta/KomponentaBrezEpredalov.vue